module.exports = __webpack_public_path__ + "img/tag_top_icon.3eb7386e.png";